import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row vh-100" }
const _hoisted_2 = { class: "col ms-2 me-5 pt-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "AI Financial Report")
], -1)
const _hoisted_4 = { class: "row mb-3 align-items-center g-2" }
const _hoisted_5 = { class: "col-auto" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = { class: "col-auto ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ReportTimeRangeFilter = _resolveComponent("ReportTimeRangeFilter")!
  const _component_AiReportChartTypeSelect = _resolveComponent("AiReportChartTypeSelect")!
  const _component_AiReportChat = _resolveComponent("AiReportChat")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.dateRangeEnabled)
              ? (_openBlock(), _createBlock(_component_ReportTimeRangeFilter, {
                  key: 0,
                  filter: _ctx.dateRangeFilter,
                  onFilterChanged: _ctx.onDateRangeChanged
                }, null, 8, ["filter", "onFilterChanged"]))
              : _createCommentVNode("", true),
            (_ctx.dateRangeEnabled)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "#",
                  class: "small ms-1",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeDateRange && _ctx.removeDateRange(...args)), ["prevent"]))
                }, "×"))
              : (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: "#",
                  class: "small",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.dateRangeEnabled = true), ["prevent"]))
                }, "+ Add date range"))
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.chartTypeEnabled)
              ? (_openBlock(), _createBlock(_component_AiReportChartTypeSelect, {
                  key: 0,
                  onChange: _ctx.onChartTypeChanged
                }, null, 8, ["onChange"]))
              : _createCommentVNode("", true),
            (_ctx.chartTypeEnabled)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "#",
                  class: "small ms-1",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeChartType && _ctx.removeChartType(...args)), ["prevent"]))
                }, "×"))
              : (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  href: "#",
                  class: "small",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.chartTypeEnabled = true), ["prevent"]))
                }, "+ Add chart type"))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-outline-secondary btn-sm",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onNewChat && _ctx.onNewChat(...args)))
            }, "New chat")
          ])
        ]),
        _createVNode(_component_AiReportChat, {
          ref: "chat",
          "date-from": _ctx.dateFrom,
          "date-to": _ctx.dateTo,
          "date-range-label": _ctx.dateRangeLabel,
          "chart-type": _ctx.chartType
        }, null, 8, ["date-from", "date-to", "date-range-label", "chart-type"])
      ])
    ])
  ]))
}